import React from 'react';

function Footer(props) {
    return (
        <>
        <div style={{width:'100%',height:`60px`,padding:`20px`,textAlign:`center`,backgroundColor:`#FFFFFF`}}>
          <p style={{fontSize:`14px`,color:`#0C1427`}}>Copyright © 2021-2021 <mark style={{color:`#4E56D4`}}>Oversoft</mark>. All rights reserved.</p>  
        </div>
        </>
    );
}

export default Footer;